import classNames from "classnames";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LoginFormContext } from "../login-form.context";
import { CheckboxComponent, TextLinkComponent } from "@gx1/gx-ui-common";
import styles from "./login-form-options.module.scss";

const LoginFormOptions = () => {
  const accountRecoveryURL = `${window.gcomWwwConnection}/account/recover`;
  const { remember, setRemember } = useContext(LoginFormContext);
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.loginOptions)}>
      <CheckboxComponent
        isChecked={remember}
        label={t("Remember Me")}
        onChange={(e) => setRemember(Boolean(e.target.checked))}
      />
      <TextLinkComponent
        href={accountRecoveryURL}
        onClick={() => window.open(accountRecoveryURL, "_self")}
        text={t("Forgot Password")}
        variant={"prominent"}
      />
    </div>
  );
};

export default LoginFormOptions;
